// Libraries
import React from 'react';

export class OverlaySpinner extends React.Component {
    constructor(props) {
        super(props);
    }

    render() {
        return (
            <div className="loading-spinner-overlay">
                <div className="loader"></div>
            </div>
            );
    }
}



// WEBPACK FOOTER //
// ./src/components/SharedComponents/overlaySpinner.js